/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { GlobalPermMap } from './GlobalPermMap';
import { NormalUser } from './NormalUser';
const ExtendedUserParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['email', /* #__PURE__ */ parsers.maybeNull(codecString)],
    [
        'emailVerified',
        /* #__PURE__ */ parsers.maybeNull(codecBoolean),
        'email_verified',
    ],
    ['hidden', codecBoolean],
    ['permissions', GlobalPermMap],
]), NormalUser);
export class ExtendedUser extends NormalUser {
    static decode(input) {
        return ExtendedUserParser.decode(input).map(res => new ExtendedUser(res));
    }
    static unsafeDecode(input) {
        return ExtendedUser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedUserParser.encode(data);
    }
    static schema() {
        return ExtendedUserParser.schema();
    }
}
